import React from 'react';

import { Btn } from '../shared/Btn';

import { RoundTableLogo } from '../../images/logos/RoundTableLogo';
import { FacebookLogoF } from '../../images/logos/FacebookLogoF';
import { InstagramLogo } from '../../images/logos/InstagramLogo';
import { TwitterLogo } from '../../images/logos/TwitterLogo';
import { YoutubeLogo } from '../../images/logos/YoutubeLogo';

import '../../../css/shared/footer.scss';
export function Footer() {
  return (
    <div className="footer">
      <div className="content">
        <div className="logo-column">
          <RoundTableLogo white/>
          <div className="slogan">
            <span className="slogan--emphasis">Freeing</span> you to do what you <span className="slogan--emphasis">love</span>.
          </div>
          <div className="logos-row">
            <FacebookLogoF/>
            <InstagramLogo/>
            <TwitterLogo/>
            <YoutubeLogo/>
          </div>
        </div>
        
        <NavbarColumns/>

        <div className="contact-column">
          <div className="text text--top">
            Couldn't find what you were looking for?
          </div>
          <div className="text text--bottom">
            Give us a call.
          </div>
          <Btn className="Btn white-outline" href="/contact">
            Contact Us
          </Btn>
        </div>
      </div>
    </div>
  )
}

function NavbarColumns () {
  return (
    <div className="navbar-columns">
      <div className="navbar-column about">
        <div className="column-header">
          About
        </div>
        <div className="options">
          <div className="option">
            <div className="underline-spaceholder"></div>
            Our Story
          </div>
          <div className="option">
            <div className="underline-spaceholder"></div>
            Our Team
          </div>
          <div className="option">
            <div className="underline-spaceholder"></div>
            Our Partners
          </div>
        </div>
        </div>
        <div className="navbar-column services">
          <div className="column-header">
            Services
          </div>
          <div className="options">
            <div className="option">
              <div className="underline-spaceholder"></div>
              Accounting
            </div>
            <div className="option">
              <div className="underline-spaceholder"></div>
              Information
            </div>
            <div className="option">
              <div className="underline-spaceholder"></div>
              Tax Services
            </div>
            <div className="option">
              <div className="underline-spaceholder"></div>
              Controls
            </div>
            <div className="option">
              <div className="underline-spaceholder"></div>
              Digital Marketing
            </div>
          </div>
        </div>
        <div className="navbar-column resources">
          <div className="column-header">
            Resources
          </div>
          <div className="options">
            <div className="option">
              <div className="underline-spaceholder"></div>
              Blog
            </div>
            <div className="option">
              <div className="underline-spaceholder"></div>
              Good Reads
            </div>
          </div>
        </div>
    </div>
  )
}